import React, { useState } from 'react';
import { Field } from 'redux-form';
import Tabs, { Tab } from 'mz-ui-kit/core/Tabs';
import { FormattedMessage } from 'mz-intl';
import ToPointIcon from 'mz-icons/to-point';
import HourlyIcon from 'mz-icons/hourly';
import ParkingIcon from './assets/ParkingIcon';
import messages from '../messages.intl';
import config from 'config';
import EsimIcon from './assets/EsimIcon';
import { isMobileBrowser } from 'app/utils/browser';
import posthog from 'posthog-js';

const FormTabs = ({ esimUrl, parkingUrl, onChange }) => {
  if (!config.SHOW_HOURLY_SEARCH && !config.SHOW_PARKING_SEARCH) return null;
  const [activeTab, setActiveTab] = useState('point_to_point');

  return (
    <Field
      name="booking_mode"
      component={({ input }) => (
        <Tabs
          activeTab={activeTab}
          appearance="rect"
          activeTabColor={config.SEARCHFORM_BACKGROUND_COLOR}
          onChange={(value) => {
            if (value === 'esim') {
              posthog.capture('eSIM Tab Clicked');
              window.open(esimUrl, '_blank');
              return;
            }
            if (value === 'parking') {
              posthog.capture('Parking Tab Clicked');
              window.open(parkingUrl, '_blank');
              return;
            }
            if (onChange) {
              onChange(value);
            }
            setActiveTab(value);
            input.onChange(value);
          }}
          initialActiveTab={input.value}
        >
          <Tab
            mobile={isMobileBrowser}
            renderIcon={() => <ToPointIcon />}
            value="point_to_point"
          >
            <FormattedMessage message={messages.POINT_TO_POINT} />
          </Tab>
          {config.SHOW_HOURLY_SEARCH && (
            <Tab
              mobile={isMobileBrowser}
              value="hourly"
              renderIcon={() => <HourlyIcon />}
            >
              <FormattedMessage message={messages.HOURLY} />
            </Tab>
          )}
          {(config.SHOW_PARKING_SEARCH ||
            // TODO: remove host name === www.mozio.com after parkvia is integrated
            location.hostname === 'www.mozio.com') && (
            <Tab
              mobile={isMobileBrowser}
              value="parking"
              renderIcon={() => <ParkingIcon />}
            >
              <FormattedMessage message={messages.PARKING} />
            </Tab>
          )}
          {config.ESIM_ENABLE && (
            <Tab
              mobile={isMobileBrowser}
              value="esim"
              renderIcon={() => <EsimIcon />}
            >
              <FormattedMessage message={messages.ESIM} />
            </Tab>
          )}
        </Tabs>
      )}
    />
  );
};

export default FormTabs;
